import { OrderSet } from '@exodus/models';
export const getOrdersInProgress = (orderSet) => {
    if (!orderSet || orderSet.size === 0)
        return OrderSet.EMPTY;
    return orderSet.filter((order) => order.exodusStatus === 'in-progress' && !order.hasOptimisticStatus);
};
const resultFunction = (isRestoring, all) => {
    if (isRestoring) {
        return OrderSet.EMPTY;
    }
    return getOrdersInProgress(all);
};
const OrdersInProgressSelectorDefinition = {
    id: 'ordersInProgress',
    resultFunction,
    dependencies: [{ module: 'application', selector: 'isRestoring' }, { selector: 'all' }],
};
export default OrdersInProgressSelectorDefinition;
